import { useEffect } from 'react';

import { useStores } from '../stores/useStores';

import { useOpenDailyBonus } from './useOpenDailyBonus';

export function useSetDailyBonusPopup() {
  const { rewardsStore } = useStores();

  const { openDailyBonus } = useOpenDailyBonus();

  useEffect(() => {
    rewardsStore.setDialogListener(openDailyBonus);
  }, [openDailyBonus, rewardsStore]);
}
